<script setup lang="ts">
import { computed } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import { ConsentBanner } from '@hatfieldmedia/hmcore'
import SiteFooter from './components/SiteFooter.vue'

const route = useRoute()

const footerRoutes = [
  'hatfield-media-credit',
  'hatfield-media-copyright',
  'hatfield-media-privacy',
  'accessibility',
]

const showFooter = computed(() => !footerRoutes.includes(route.name as string))
</script>

<template>
  <RouterView />
  <SiteFooter v-if="showFooter" />
  <ConsentBanner />
</template>
